const e=async(e,t)=>{let{data:n}=await e.get(`/apps/${t}/terms`);return n};export{e as getTerms};
//# sourceMappingURL=get-terms.mjs.map